// 倒计时
$(document).ready(function() {
    // 计算 2 天 15 小时 34 分 55 秒的总秒数
    let totalSeconds = (2 * 24 * 60 * 60) + (15 * 60 * 60) + (34 * 60) + 55;

    // 每秒更新一次倒计时
    const countdownInterval = setInterval(function() {
        if (totalSeconds <= 0) {
            clearInterval(countdownInterval);
            $('.countdown_day').text('00');
            $('.countdown_hour').text('00');
            $('.countdown_minute').text('00');
            $('.countdown_second').text('00');
            // 移除月份显示逻辑，因为初始时间不涉及月份
            $('.countdown_month').parent().hide(); 
            return;
        }

        // 计算天、小时、分钟、秒
        let days = Math.floor(totalSeconds / (24 * 60 * 60));
        let remainingSecondsAfterDays = totalSeconds % (24 * 60 * 60);
        let hours = Math.floor(remainingSecondsAfterDays / (60 * 60));
        let remainingSecondsAfterHours = remainingSecondsAfterDays % (60 * 60);
        let minutes = Math.floor(remainingSecondsAfterHours / 60);
        let seconds = remainingSecondsAfterHours % 60;

        // 更新显示
        $('.countdown_day').text(String(days).padStart(2, '0'));
        $('.countdown_hour').text(String(hours).padStart(2, '0'));
        $('.countdown_minute').text(String(minutes).padStart(2, '0'));
        $('.countdown_second').text(String(seconds).padStart(2, '0'));

        // 减少总秒数
        totalSeconds--;
    }, 1000);
});
var plan_lists = [5,6,7,8,9];
$('.buy_tab>div span').click(function(){
    $(this).addClass('active').siblings().removeClass('active')
    $('.buy_main .buy_box').eq($(this).index()).addClass('active').siblings().removeClass('active')
})
$('.buy_box>div .check_box>div i').click(function(){
    var _index;
    for(var i = 0;i<$(this).parent().siblings('ul').find('li').length;i++){
        if($(this).parent().siblings('ul').find('li').eq(i).hasClass('active')){
            _index = i;
        }
    }
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
        $(this).parent().parent().siblings('.btn').attr('plan',$(this).parent().parent().siblings('.btn').attr('attr-plan')+','+plan_lists[_index]);
    }else{
        $(this).parent().parent().siblings('.btn').attr('plan',$(this).parent().parent().siblings('.btn').attr('attr-plan'));
    }
})
$(document).click(function(){
    $('.buy_box>div .check_box ul').hide()
})
$('.buy_box>div .check_box>div p').click(function(e){
    e.stopPropagation();
    var _flag = true;
    $(this).parent().siblings('ul').toggle();
})
$('.buy_box>div .check_box ul li').click(function(){
    var _index = $(this).index();
    $(this).addClass('active').siblings().removeClass('active')
    $(this).parent().parent().find('p').html($(this).html());
    if($(this).parent().siblings('div').find('i').hasClass('active')){
        $(this).parent().parent().siblings('.btn').attr('plan',$(this).parent().parent().siblings('.btn').attr('attr-plan')+','+plan_lists[_index]);
    }
})
$('.table_main .show_table').click(function(){
    $(this).toggleClass('active')
    $(this).next().find('table').toggleClass('active')
})
$('.faq_box>div .title').click(function(){
    $(this).parent().toggleClass('active').siblings().removeClass('active')
})
function getQueryVariable(variable){
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
    }
    return(false);
}
var buy_first=0;
var isbuy=0;
window.open_google = true;
// ga跟踪代码
function gaPush(dataEvent,lable){
    try{
        // _gaq.push(['_trackEvent',operation,String(dataEvent),String(lable)]);
    }catch(e){
        // console.log(e)
    }
}
// 判断是否首次进入页面
if(localStorage.getItem('buy_first')){
    buy_first=1
}else{
    localStorage.setItem('buy_first',1)
}
if(location.hostname=='www.vidhex.ai'
){
    var paddle_vendor=183001;
    var fast_storefront='vidhexai.onfastspring.com/popup-vidhexai';
    var fast_key='D9D2TTX6S4CFIMIRVYSQ0G';
}else{
    // Paddle.Environment.set('sandbox');
    var paddle_vendor=570;
    var fast_storefront='vidhexai.test.onfastspring.com/popup-vidhexai';
    var fast_key='D9D2TTX6S4CFIMIRVYSQ0G';
}
var fastspringScript
// 请求购买链接
$('.buy_box span.btn').click(function(){
    if($(this).attr('class').indexOf('load')>-1){
        return false;
    }
    checkout($(this));
});
function checkout(that){
    var data={
        e_id:murmur,
        gateway:gateway,
        plan_id:that.attr('plan'),
    }
    gaPush('buy_fail','buy_planID',that.attr('plan'))
    that.addClass('load')
    $.post(
        post_url+"subscription/checkout",
        data,
        function(data){
            error_fn(data.error,that);
            switch(data.error){
                case 0:
                    if(gateway==4){
                        // 2checkout
                        (function (document, src, libName, config,data) {
                            var data=getUrlkey(data.url_gateway)
                            var script             = document.createElement('script'); 
                            script.src             = src; 
                            script.async           = true; 
                            script.id              ='buy2checkout'
                            var firstScriptElement = document.getElementsByTagName('script')[0]; 
                            script.onload          = function () {
                                $('.buy_box .btn').removeClass('load');
                                var isbuy=0;
                                for (var namespace in config) {
                                    if (config.hasOwnProperty(namespace)) {
                                        window[libName].setup.setConfig(namespace, config[namespace]);
                                    } 
                                } 
                                window[libName].register();
                                TwoCoInlineCart.products.add({
                                    code: data.prod,
                                    quantity: data.qty,
                                });
                                try{
                                    if(data.test){
                                        TwoCoInlineCart.cart.setTest(true);
                                    }
                                }catch(e){
                                    console.log(e)
                                }
                                if(data.lock){
                                    TwoCoInlineCart.cart.setCartLockedFlag(true)
                                }else{
                                    TwoCoInlineCart.cart.setCartLockedFlag(false);
                                }
                                if(data['empty-cart']){
                                    TwoCoInlineCart.cart.setReset(true)
                                }else{
                                    TwoCoInlineCart.cart.setReset(false)
                                }
                                TwoCoInlineCart.cart.setExpiration(data.expiration)
                                TwoCoInlineCart.cart.setSignature(data.signature)
                                // TwoCoInlineCart.cart.setOrderExternalRef(data['order-ext-ref'])
                                TwoCoInlineCart.cart.setExternalCustomerReference(data['customer-ext-ref'])
                                TwoCoInlineCart.cart.checkout();
                                TwoCoInlineCart.events.subscribe('cart:opened', function () {
                                    console.log('cart:opened')
                                })
                                TwoCoInlineCart.events.subscribe('cart:closed', function () {
                                    if(isbuy){
                                        $('.maskRights').show();
                                        if(getCookie('user')){
                                            $('.buySuccess.Member').show().siblings().hide();
                                            gaPush('buy_login','true')
                                        }else{
                                            $('.buySuccess.noMember').show().siblings().hide();
                                            gaPush('buy_login','false')
                                        }
                                    }
                                })
                                TwoCoInlineCart.events.subscribe('payment:finalized', function () {
                                    isbuy=1;
                                    gaPush('buy_success','')
                                })
                            }; 
                            firstScriptElement.parentNode.insertBefore(script, firstScriptElement); 
                        })(document, 'https://secure.2checkout.com/checkout/client/twoCoInlineCart.js', 'TwoCoInlineCart',{"app":{"merchant":getUrlkey(data.url_gateway).merchant,"iframeLoad":"checkout"},"cart":{"host":"https:\/\/secure.2checkout.com","customization":"inline"}},data); 
                    }else if(gateway==6){
                        $('.maskRights').show()
                        if(getCookie('user')){
                            $('.buySuccess.Member').show().siblings().hide();
                        }else{
                            $('.buySuccess.noMember').show().siblings().hide();
                        }
                        console.log("3",newWindow);
                        newWindow.location.href = data.url_gateway;
                    }else if(gateway==7){
                        var key=JSON.parse(window.atob(data.url_gateway.split('base64,')[1]));
                        console.log(key);
                        if(fastspringScript){
                            $('.buy_box .btn').removeClass('load');
                            fastspring.builder.promo(that.attr('coupon'))
                            fastspring.builder.secure(key.p,key.k)
                            fastspring.builder.checkout();
                        }else{
                            fastspringScript=document.createElement('script'); 
                            fastspringScript.src="https://sbl.onfastspring.com/sbl/1.0.1/fastspring-builder.min.js"; 
                            fastspringScript.async=true; 
                            fastspringScript.id='fsc-api'
                            fastspringScript.setAttribute('data-storefront',fast_storefront)
                            fastspringScript.setAttribute('data-access-key',fast_key)
                            fastspringScript.setAttribute('data-access-key',fast_key)
                            fastspringScript.setAttribute('data-popup-closed','dataPopupClosed')
                            fastspringScript.setAttribute('data-popup-webhook-received','dataPopupWebhookReceived')
                            document.body.appendChild(fastspringScript)
                            fastspringScript.onload=function(){
                                $('.buy_box .btn').removeClass('load');
                                fastspring.builder.promo(that.attr('coupon'))
                                fastspring.builder.secure(key.p,key.k)
                                fastspring.builder.checkout();
                            }
                        }
                    }else{
                        // isbuy=0;
                        // Paddle.Checkout.open({
                        //     override: data.url_gateway
                        // });
                    }
                    break
                case 25301:
                    that.removeClass('load')
                    error(i18n[lang].error_25301);
                    break;
                case 25302:
                    that.removeClass('load')
                    error(i18n[lang].error_25302);
                    break;
                case 25303:
                    that.removeClass('load')
                    error(i18n[lang].error_25303);
                    break;
                case 25304:
                    that.removeClass('load')
                    error(i18n[lang].error_25304);
                    break;
                case 25305:
                    that.removeClass('load')
                    error(i18n[lang].error_25305);
                    break;
                case 25306:
                    that.removeClass('load')
                    error(i18n[lang].error_25306);
                    break;
            }
        }
    ).error(function(xhr){
        that.removeClass('load')
        overtime(25399);
    });
}
// fastspring关闭回调
function dataPopupClosed(){
    if(isbuy){
        $('.maskRights').show();
        if(getCookie('user')){
            $('.buySuccess.Member').show().siblings().hide();
            gaPush('buy_login','true')
        }else{
            $('.buySuccess.noMember').show().siblings().hide();
            gaPush('buy_login','false')
        };

    }
}
// fastspring购买成功回调
function dataPopupWebhookReceived(){
    isbuy=1;
};
$(document).ready(function(){
    if(window.location.search != ''){
      var value = getQueryVariable('plan_id');
      for(var j=0;j<$('.buy_main span.btn').length;j++){
        if($('.buy_main span.btn').eq(j).attr('attr-plan')==value.split(',')[0]){
            if(value.split(',')[1]){
                $('.buy_main span.btn').eq(j).siblings('.check_box').find('i').trigger('click');
                $('.buy_main span.btn').eq(j).siblings('.check_box').find('li').eq(value.split(',')[1]-5).trigger('click');
            }
            checkout($('.buy_main span.btn').eq(j));
        }
      }
    }
});
